<template>
    <div>
        <div class="kqf-card mg10 pd10 pt30 mt30  mr60" v-loading="loading" style="display: flex;width:100%;height:100vh">
            
                <!-- <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="标题：" required>
                        <el-input v-model="form.title"></el-input>
                        <p class="form-tip">新闻标题，同SEO标题</p>
                    </el-form-item>
                    <el-form-item label="摘要：" required>
                        <el-input v-model="form.abstract"></el-input>
                        <p class="form-tip">新闻摘要，</p>
                    </el-form-item>
                    <el-form-item label="分类">
                        <select-article-cat   v-model="form.category_id"></select-article-cat>
                    </el-form-item>
                    <el-form-item label="关键字：" >
                        <el-input v-model="form.keywords"></el-input>
                        <p class="form-tip">SEO 关键字</p>
                    </el-form-item>
                    <el-form-item label="描述：" >
                        <el-input v-model="form.description"></el-input>
                        <p class="form-tip">SEO 描述</p>
                    </el-form-item>
                    <el-form-item label="图片：" required>
                        <upload-one w="77px" h="60px" v-model="form.image"></upload-one>
                        <p class="form-tip">建议尺寸 154 * 120  或等比例缩放</p>
                    </el-form-item>
                    <el-form-item label="内容：" required>
                        <html-editor v-model="form.content" type="pc"></html-editor>
                    </el-form-item>
                    <el-form-item label="推荐：" required>
                        <el-switch v-model="form.recommend" active-value="2" inactive-value="1"></el-switch>
                    </el-form-item>
                    <el-form-item label="启用：" required>
                        <el-switch v-model="form.status" active-value="1" inactive-value="2"></el-switch>
                    </el-form-item>
                    <el-form-item label="排序：" required>
                        <el-input-number v-model="form.sort"  :min="0" ></el-input-number>
                        <p class="form-tip">数字越大越靠前</p>
                    </el-form-item>
                </el-form> -->
          <el-form ref="form" :model="form" style="width:100%;">
          <el-table-column label="操作" >
            <div class="flex">
              <el-form-item label="标题：" label-width="100px" style="width: 40%;"  required>
                <el-input
                  v-model="form.title"
                  placeholder="新闻标题，同SEO标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="摘要：" label-width="100px" style="width: 40%;margin-left:5%" required>
                <el-input
                  v-model="form.abstract"
                  placeholder="新闻摘要"
                ></el-input>
              </el-form-item>
            </div>
          </el-table-column>
          <div class="flex">
            <el-form-item label="关键字：" label-width="100px" style="width: 40%;">
              <el-input
                v-model="form.keywords"
                placeholder="SEO 关键字"
              ></el-input>
            </el-form-item>
            <el-form-item label="描述：" label-width="100px" style="width: 40%;margin-left:5%">
              <el-input
                v-model="form.description"
                placeholder="SEO 描述"
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="分类：" label-width="100px" style="width: 40%;">
              <select-article-cat
                v-model="form.category_id"
              ></select-article-cat>
            </el-form-item>
            <el-form-item label="排序："  label-width="100px" style="width: 40%;margin-left:5%" required>
              <el-input-number v-model="form.sort" :min="0"></el-input-number>
            </el-form-item>
          </div>
          <div class="flex" >
            <el-form-item label="推荐：" label-width="100px" style="width: 40%;" required>
              <el-switch
                v-model="form.recommend"
                :active-value="2"
                :inactive-value="1"
              ></el-switch>
            </el-form-item>
            <el-form-item label="启用："  label-width="100px" style="width: 40%;margin-left:5%" required>
              <el-switch
                v-model="form.status"
                :active-value="1"
                :inactive-value="2"
              ></el-switch>
            </el-form-item>
              <el-form-item label="微信专属：" label-width="100px" required>
                  <el-switch v-model="form.exclusive" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
          </div>
          <el-form-item label="图片：" label-width="100px" style="width: 40%;" required>
            <upload-one w="80px" h="80px" v-model="form.image"></upload-one>
            <!-- <p class="form-tip">建议尺寸 154 * 120 或等比例缩放</p> -->
          </el-form-item>
          <el-form-item label="内容："  label-width="100px" required>
            <html-editor v-model="form.content" type="pc"></html-editor>
          </el-form-item>
          <!-- <el-form-item>
            <el-button
              type="primary"
              size="medium"
              style="margin: 20px 0 0px 0px"
              @click="editsArticle"
              >保存</el-button
            >
          </el-form-item> -->
           <div mt30 style="text-align:center">
            <div>
                <el-button icon="el-icon-arrow-left" @click="toList" type="text" style="margin-right: 30px">返回列表</el-button>
                <el-button icon="el-icon-check"  type="primary" size="medium" @click="editsArticle">提交保存</el-button>
            </div>
        </div>
        </el-form>
            </div>
     
       
    </div>
</template>
<script>
    import UploadOne from "../../components/upload/UploadOne";
    import HtmlEditor from "../../components/editer/Editer";
    import{editsArticle,getEditData} from "../../request/api/article/article";
    import SelectArticleCat from "./components/SelectArticleCat";
    export default {
        components: {SelectArticleCat, UploadOne,HtmlEditor},
        data(){
            return{
                loading:false,
                form:{
                    title:'',
                    description:'',
                    keywords:'',
                    category_id: '',
                    image:'',
                    content:'',
                    abstract:'',
                    recommend:'',
                    introduction_video:'',
                    detailed_video:'',
                    sort:'',
                    status:'',
                    exclusive:'',
                }
            }
        },
        created() {
            this.geteditDatas();
        },
        methods:{
            toList(){
                this.$router.push("/article/index")
            },
            editsArticle(){
                this.loading = true;
                editsArticle({
                    id:this.$route.query.id,
                    title:this.form.title,
                    category_id:this.form.category_id,
                    keywords:this.form.keywords,
                    description:this.form.description,
                    image:this.form.image,
                    content:this.form.content,
                    abstract:this.form.abstract,
                    recommend:this.form.recommend,
                    introduction_video:this.form.introduction_video,
                    detailed_video:this.form.detailed_video,
                    sort:this.form.sort,
                    status:this.form.status,
                    exclusive:this.form.exclusive,
                }).then(() => {
                    this.loading = false;
                    this.$message.success("操作成功");
                    setTimeout(() =>{
                        this.toList();
                    },500);
                }).catch(() => {
                    this.loading = false;
                })
            },
            geteditDatas(){
                this.loading = true;
                getEditData({
                    id:this.$route.query.id,
                }).then(res => {
                    this.form=res;
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                })
            }


        },
    }
</script>
<style scoped>

</style>